import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { Input } from "@/components/ui/input";
import { Badge } from "@/components/ui/badge";

export default function AuditLog() {
  const [items, setItems] = useState([]);
  const [filter, setFilter] = useState("");

  useEffect(() => {
    api.get("/audit", { params: { limit: 300 } }).then(({ data }) => setItems(data));
  }, []);

  const visible = items.filter((i) => {
    if (!filter) return true;
    const f = filter.toLowerCase();
    return (i.action || "").toLowerCase().includes(f)
      || (i.entity_type || "").toLowerCase().includes(f)
      || (i.actor_email || "").toLowerCase().includes(f);
  });

  return (
    <div className="p-4 sm:p-6 lg:p-8 space-y-4 sm:space-y-6" data-testid="audit-log-page">
      <div>
        <h1 className="font-display text-2xl sm:text-3xl font-black">Audit trail</h1>
        <p className="text-muted-foreground">Every state-changing action is recorded here with actor, IP, timestamp and old/new values.</p>
      </div>
      <Input placeholder="Filter by action, entity, or user email…" value={filter} onChange={(e) => setFilter(e.target.value)} data-testid="audit-filter" />
      <div className="surface-card p-4 overflow-x-auto">
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead>When</TableHead>
              <TableHead>Actor</TableHead>
              <TableHead>Action</TableHead>
              <TableHead>Entity</TableHead>
              <TableHead>Entity ID</TableHead>
              <TableHead>IP</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {visible.map((i) => (
              <TableRow key={i.id} data-testid={`audit-row-${i.id}`}>
                <TableCell className="font-mono text-xs">{new Date(i.created_at).toLocaleString()}</TableCell>
                <TableCell className="text-sm">{i.actor_email}</TableCell>
                <TableCell><Badge variant="outline" className="font-mono text-[10px]">{i.action}</Badge></TableCell>
                <TableCell className="text-sm">{i.entity_type}</TableCell>
                <TableCell className="font-mono text-[10px] text-muted-foreground">{(i.entity_id || "").slice(0, 8)}</TableCell>
                <TableCell className="font-mono text-[10px] text-muted-foreground">{i.ip || "—"}</TableCell>
              </TableRow>
            ))}
            {visible.length === 0 && (
              <TableRow><TableCell colSpan={6} className="text-center text-muted-foreground py-8">No audit records.</TableCell></TableRow>
            )}
          </TableBody>
        </Table>
      </div>
    </div>
  );
}
